import React, { Component } from 'react';
import { connect } from "react-redux";


import PasswordModal from "components/PasswordModal/PasswordModal";

import { Well, FormGroup, ControlLabel, Button } from "react-bootstrap";

import NumberFormat from 'react-number-format';

import { fetchDisbursementInfo, saveDisbursementRequest } from 'reducers/disbursementrequest/disbursementrequestActions';

import { formatToDecimal, roundNumber } from "utils/Number/NumberUtils"

import { showWarningMessage, showSuccessfulMessage } from "reducers/application/applicationActions";

import classNames from 'classnames';

import Auth from "../../auth/Auth";

class DisbursementRequest extends Component {
    user;
    auth;
    constructor(props) {
        super(props);
        this.auth = new Auth();
        this.user = this.auth.getUser();
        this.state = {
            amount: 0,
            amountError: null,
            showPasswordModal: false,
            passwordModalLoading: false,
            signed: this.user.signed
        };
    }

    componentWillMount() {
        this.props.fetchDisbursementInfo();
    }

    valid = () => {
        if (!this.state.signed) {
            this.props.showWarningMessage("Ud. no completó la firma del contrato, no puede solicitar desembolsos");
            return false;
        }

        if (this.state.amount == null || this.state.amount == undefined || this.state.amount <= 0) {
            this.props.showWarningMessage("Por favor ingrese un monto válido a solicitar");
            this.setState({ amountError: "Ingrese un monto válido a solicitar" });
            return false;
        }

        if (this.state.amount > this.props.disbursementInfo.availableAmountAccount) {
            this.props.showWarningMessage("El monto solicitado no puede ser mayor al saldo disponible");
            return false;
        }
        return true;
    }


    cleanAmountError() {
        this.setState({ amountError: null });
    }

    showPasswordModal = () => {
        if (this.valid()) {
            this.setState({ showPasswordModal: true })
        }
    }

    requestDisbursement(password) {
        this.setState({ passwordModalLoading: true });

        let promise = new Promise((resolve, reject) => {
            let requestDto = {
                amount: this.state.amount,
                password: password
            }
            this.props.saveDisbursementRequest(requestDto, resolve, reject);
        });
        promise.then(() => {
            this.props.showSuccessfulMessage("Solicitud de desembolso enviada correctamente");
            this.props.fetchDisbursementInfo();
            this.setState({
                amount: 0,
                amountError: null,
                showPasswordModal: false,
                passwordModalLoading: false
            });
        }, () => {
            this.setState({
                passwordModalLoading: false
            });
        });
    }

    render() {
        const { amountError } = this.state;
        const amountClass = classNames('form-group',
            { 'has-error': amountError != null }
        );
        return (
            <div>
                <div className="d-flex justify-content-center align-items-center">
                    <Well bsSize="large" bsClass="wallet_transfer__card">

                        <div className="wallet-transfer__balance_cont">
                            {this.props.disbursementInfo != null &&
                                <div>
                                    <div className="wallet-transfer__balance">
                                        <b>Saldo Disponible: </b><span><b>{formatToDecimal(roundNumber(this.props.disbursementInfo.availableAmountAccount))} {this.props.disbursementInfo.currency}</b></span>
                                    </div>

                                    <div className="wallet-transfer__balance">
                                        <b>Total Solicitado: </b><span><b>{formatToDecimal(roundNumber(this.props.disbursementInfo.totalRequested))} {this.props.disbursementInfo.currency}</b></span>
                                    </div>
                                </div>
                            }
                        </div>


                        <div className={amountClass}>
                            <ControlLabel><b>Monto a solicitar</b></ControlLabel> <br />
                            <NumberFormat
                                className="form-control input-sm form-control-sm wallet-transfer__amount"
                                value={this.state.amount}
                                decimalScale={2}
                                thousandSeparator={true}
                                suffix={'Bs'}
                                onValueChange={(values) => {
                                    const { formattedValue, value } = values;
                                    // formattedValue = $2,223
                                    // value ie, 2223
                                    if (value != null && value != undefined && value > 0) {
                                        this.cleanAmountError();
                                    }
                                    this.setState({ amount: value })
                                }} />
                            <span className="help-block">{amountError}</span>
                        </div>

                        <FormGroup>
                            <Button className="bg-light-secondary float-right" onClick={this.showPasswordModal}>Solicitar Desembolso</Button>
                        </FormGroup>
                    </Well>
                </div>

                <PasswordModal
                    show={this.state.showPasswordModal}
                    loading={this.state.passwordModalLoading}
                    onHide={() => this.setState({ showPasswordModal: false })}
                    save={(password) => this.requestDisbursement(password)}
                    buttonLabel="Confirmar Solicitud de Desembolso"
                />

            </div>
        )
    }
}

const mapStateToProps = state => ({
    disbursementInfo: state.disbursementrequest.info
});

export default connect(mapStateToProps,
    {
        fetchDisbursementInfo,
        saveDisbursementRequest,
        showWarningMessage,
        showSuccessfulMessage
    })(DisbursementRequest);



// WEBPACK FOOTER //
// ./src/components/DisbursementRequest/DisbursementRequest.jsx